import './text-input-group.css';
export default {
  "labelGroupMain": "pf-v6-c-label-group__main",
  "modifiers": {
    "disabled": "pf-m-disabled",
    "plain": "pf-m-plain",
    "success": "pf-m-success",
    "warning": "pf-m-warning",
    "error": "pf-m-error",
    "status": "pf-m-status",
    "icon": "pf-m-icon",
    "hint": "pf-m-hint"
  },
  "textInputGroup": "pf-v6-c-text-input-group",
  "textInputGroupGroup": "pf-v6-c-text-input-group__group",
  "textInputGroupIcon": "pf-v6-c-text-input-group__icon",
  "textInputGroupMain": "pf-v6-c-text-input-group__main",
  "textInputGroupText": "pf-v6-c-text-input-group__text",
  "textInputGroupTextInput": "pf-v6-c-text-input-group__text-input",
  "textInputGroupUtilities": "pf-v6-c-text-input-group__utilities"
};